var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sides"},[_c('li',[_vm._v("+ твой успех +")]),_c('li',[_vm._v("+ твой KIA +")])])}]

export { render, staticRenderFns }